import { sqliteTable, text, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// leave_types — ประเภทวันลา (Leave Type)
// ============================================================================
export const leaveTypes = sqliteTable("hr_leave_types", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  name: text("name").notNull(), // ลาป่วย, ลาพักร้อน, ลากิจ, etc.
  maxDaysPerYear: integer("max_days_per_year").notNull().default(0),
  isPaid: integer("is_paid").notNull().default(1), // 1=paid, 0=unpaid
  requiresApproval: integer("requires_approval").notNull().default(1),
  allowCarryForward: integer("allow_carry_forward").notNull().default(0),
  maxCarryForwardDays: integer("max_carry_forward_days").notNull().default(0),
  isActive: integer("is_active").notNull().default(1),
  // Audit columns
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  lt_company_idx: index("lt_company_idx").on(table.companyId, table.isActive),
}));

// Type exports
export type LeaveType = typeof leaveTypes.$inferSelect;
export type NewLeaveType = typeof leaveTypes.$inferInsert;
